
// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

$(window).on("load", function() {
       
    defineAnimation();
    scrollAnimation();
    footerAnim();

    if (document.querySelector('.section-yoghurt')) {
        illustAnim();
    }

    if (document.querySelector('.section-ticker')) {
        logoTicker();
    }

    if (document.querySelector('.marquee')) {
        marquee();
    }

    if (document.querySelector('.section-family')) {
        socialsCarousel();
    }
});

$(document).ready(function(){

    runLenis();
    
	$('#header .toggle, .header-alt .toggle').click(function(){
		$('.mobile-menu').toggleClass('active');
	});

	$('.mobile-menu .close').click(function(){
		$('.mobile-menu').removeClass('active');
	});

    $('.accordion').on('click', '.heading', function() {
        const $this = $(this);
        const $content = $this.next('.content');

        // Check if the clicked item is already active
        if ($this.hasClass('active')) {
            // Close current item
            $this.removeClass('active');
            $content.slideUp(300);
        } else {
            // Close all other active headings and content blocks
            $('.accordion .heading').removeClass('active');
            $('.accordion .content').slideUp(300);

            // Open clicked item
            $this.addClass('active');
            $content.slideDown(300);
        }
    });

    $('.section-story').mousemove(function(e){
        var wx = $(window).width();
        var wy = $(window).height();
        
        var x = e.pageX - this.offsetLeft;
        var y = e.pageY - this.offsetTop;
        
        var newx = x - wx/2;
        var newy = y - wy/2;
        
        $('.section-story .parallax-wrap').each(function(){
            var speed = $(this).attr('data-speed');
            if($(this).attr('data-revert')) speed *= -1;
            
            // Modern GSAP v3 syntax
            gsap.to($(this), {
                duration: 1, 
                x: (1 - newx * speed), 
                y: (1 - newy * speed),
                overwrite: 'auto' // Prevents tweens from fighting if mousemove fires too fast
            });
        });
    });

    $('.section-yoghurt').mousemove(function(e){
        var wx = $(window).width();
        var wy = $(window).height();
        
        var x = e.pageX - this.offsetLeft;
        var y = e.pageY - this.offsetTop;
        
        var newx = x - wx/2;
        var newy = y - wy/2;
        
        $('.section-yoghurt .parallax-wrap').each(function(){
            var speed = $(this).attr('data-speed');
            if($(this).attr('data-revert')) speed *= -1;
            
            // Modern GSAP v3 syntax
            gsap.to($(this), {
                duration: 1, 
                x: (1 - newx * speed), 
                y: (1 - newy * speed),
                overwrite: 'auto' // Prevents tweens from fighting if mousemove fires too fast
            });
        });
    });

    $('.section-amb3').mousemove(function(e){
        var wx = $(window).width();
        var wy = $(window).height();
        
        var x = e.pageX - this.offsetLeft;
        var y = e.pageY - this.offsetTop;
        
        var newx = x - wx/2;
        var newy = y - wy/2;
        
        $('.section-amb3 .parallax-wrap').each(function(){
            var speed = $(this).attr('data-speed');
            if($(this).attr('data-revert')) speed *= -1;
            
            // Modern GSAP v3 syntax
            gsap.to($(this), {
                duration: 1, 
                x: (1 - newx * speed), 
                y: (1 - newy * speed),
                overwrite: 'auto' // Prevents tweens from fighting if mousemove fires too fast
            });
        });
    });

    $('.hero-slider').on('init', function(event, slick) {
        //heroAnim($(this).find('.slick-slide.slick-active'));
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        /*
        const $allElements = $(this).find('.mask span, h2, .link');
        gsap.killTweensOf($allElements);
        gsap.set($allElements, {
            autoAlpha: 0
        });*/
    }).on('afterChange', function(event, slick, currentSlide) {
        //heroAnim($(this).find('.slick-slide.slick-active'));
    }).slick({
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false
    });

    $('.product-slider').on('init', function(event, slick) {
        if (slick.$slides.length <= 1) {
            $('.slick-dots').hide();
        }
    });
    $('.product-slider').slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
        fade: true,
        pauseOnHover: false
    });

    $('.section-product-carousel .slider').slick({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows:true,
        centerMode:true,
        variableWidth:true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots:true,
                    arrows:false
                }
            }
        ]
    });

    $('.section-inspiration .slider').slick({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows:true,
        centerMode:true,
        variableWidth:true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.testimonial-slider').slick({
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });

    const $slider = $('.tl-slider-main');
    const lastSlideIndex = $slider.children().length - 1;
    // Initialize the single main slider
    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        //initialSlide: lastSlideIndex,
        adaptiveHeight:true,
        dots:false,
        fade:true
    });

    // 1. Click label to change slide
    $('.tl-static-labels').on('click', '.item', function() {
        const slideIndex = $(this).data('slide');
        $slider.slick('slickGoTo', slideIndex);
    });

    // 2. Change active label class when slider moves (via arrows, swipe, etc.)
    $slider.on('afterChange', function(event, slick, currentSlide){
        $('.tl-static-labels .item').removeClass('active');
        $(`.tl-static-labels .item[data-slide="${currentSlide}"]`).addClass('active');
    });

    $('.tl-slider-main, .hero-slider, .section-product-carousel .slider, .section-inspiration .slider, .product-slider, .testimonial-slider').on('setPosition afterChange', function() {
        ScrollTrigger.refresh();
    });
    

});

function heroAnim($currentSlide) {
    const headingSpans = $currentSlide.find('.mask span');
    const heading2 = $currentSlide.find('h2');
    const headingLink = $currentSlide.find('.link');
    gsap.killTweensOf([headingSpans, heading2, headingLink]);
    const tl = gsap.timeline();
    tl.fromTo(headingSpans, {
        autoAlpha: 0,
        yPercent: 100
    }, {
        duration: 1.2,
        autoAlpha: 1,
        yPercent: 0,
        ease: "power4.out",
        stagger: 0.2
    }).fromTo(heading2, {
        autoAlpha: 0,
        yPercent: 50
    }, {
        duration: 1,
        autoAlpha: 1,
        yPercent: 0,
        ease: "power4.out"
    }, "-=0.5").fromTo(headingLink, {
        autoAlpha: 0
    }, {
        duration: 1,
        autoAlpha: 1,
        ease: "power4.out"
    }, "-=0.5");
}


function illustAnim(){
    // 1. Find the specific parent container
    const container = document.querySelector(".section-yoghurt");
    
    // Safety check: if the section doesn't exist on this page, exit early
    if (!container) return;

    // 2. Create a scoped selector bound strictly to this section
    const q = gsap.utils.selector(container);

    const timelineInstance = gsap.timeline({
      scrollTrigger: {
        trigger: q(".wrapper"), // Scoped to .section-yoghurt .wrapper
        start: "top 40%", 
        toggleActions: "play none none none" 
      }
    });

    // 3. Use 'q()' around every selector string to lock it down
    timelineInstance
      // 1. Tags zoom-in sequentially
      .from(q(".tag-1"), { scale: 0, opacity: 0, duration: 0.5, ease: "back.out(1.7)" })
      .from(q(".tag-2"), { scale: 0, opacity: 0, duration: 0.5, ease: "back.out(1.7)" }, "<")
      
      // 2. Arrow 1 (fade-left) then Text 1 (fade-up)
      .from(q(".arrow:not(.arrow-2):not(.arrow-3):not(.arrow-4)"), { x: 40, opacity: 0, duration: 0.4, ease: "power2.out" })
      .from(q(".text:not(.text-2):not(.text-3):not(.text-4)"), { y: 30, opacity: 0, duration: 0.4, ease: "power2.out" }, "-=0.1")

      // 3. Arrow 3 (fade-right) then Text 3 (fade-up)
      .from(q(".arrow-3"), { x: -40, opacity: 0, duration: 0.4, ease: "power2.out" })
      .from(q(".text-3"), { y: 30, opacity: 0, duration: 0.4, ease: "power2.out" }, "-=0.1")

      // 4. Arrow 2 (fade-left) then Text 2 (fade-up)
      .from(q(".arrow-2"), { x: 40, opacity: 0, duration: 0.4, ease: "power2.out" })
      .from(q(".text-2"), { y: 30, opacity: 0, duration: 0.4, ease: "power2.out" }, "-=0.1")

      // 5. Arrow 4 (fade-right) then Text 4 (fade-up)
      .from(q(".arrow-4"), { x: -40, opacity: 0, duration: 0.4, ease: "power2.out" })
      .from(q(".text-4"), { y: 30, opacity: 0, duration: 0.4, ease: "power2.out" }, "-=0.1");
}

function defineAnimation(){
    if (document.querySelector('.hero')) {
        $('.hero').each(function() {
            const section = $('body');
            const bg = $(this).find('.bg');
            const distance = section.hasClass('hero') ? 500 : 300;

            gsap.to(bg, {
                y: distance,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    start: "top top",
                    end: "bottom top",
                    scrub: true
                }
            });
        });
    }

    //section-media
    if (document.querySelector('.section-media')) {
        gsap.from(".section-media .icons ul li", {
            scrollTrigger: {
                trigger: ".section-media",    // Element that kicks off the animation
                start: "top 50%",             // "When the top of the section hits 80% down the viewport"
                toggleActions: "play none none none" // Plays once when entering, doesn't reverse on scroll up
            },
            
            duration: 1.2,
            y: 40,                            // Fade up from 40px down
            opacity: 0,
            ease: "power2.out",
            stagger: 0.15                     // Stagger delay between each <li>
        });
    }

    //section-ideas
    if (document.querySelector('.section-ideas')) {
        gsap.from(".section-ideas .cards .tag", {
            scrollTrigger: {
                trigger: ".section-ideas",    // Element that kicks off the animation
                start: "top 20%",             // "When the top of the section hits 80% down the viewport"
                toggleActions: "play none none none" // Plays once when entering, doesn't reverse on scroll up
            },
            
            duration: 0.5,
            scale: 0,                            
            opacity: 1,
            ease: "back.out(1.7)",
            stagger: 0.25
        });
    }

    //section-story2
    if (document.querySelector('.section-story2')) {
        gsap.from(".section-story2 .cards .tag", {
            scrollTrigger: {
                trigger: ".section-story2",    // Element that kicks off the animation
                start: "top 20%",             // "When the top of the section hits 80% down the viewport"
                toggleActions: "play none none none" // Plays once when entering, doesn't reverse on scroll up
            },
            
            duration: 0.5,
            scale: 0,                            
            opacity: 1,
            ease: "back.out(1.7)",
            stagger: 0.25
        });
    }

    //section-amb1
    if (document.querySelector('.section-amb1')) {
        gsap.from(".section-amb1 .cards .tag", {
            scrollTrigger: {
                trigger: ".section-amb1",    // Element that kicks off the animation
                start: "top 10%",             // "When the top of the section hits 80% down the viewport"
                toggleActions: "play none none none" // Plays once when entering, doesn't reverse on scroll up
            },
            
            duration: 0.5,
            scale: 0,                            
            opacity: 1,
            ease: "back.out(1.7)",
            stagger: 0.25
        });
    }

    //section-products
    if (document.querySelector('.section-products')) {
        const columns = gsap.utils.toArray(".section-products .item .column");
        columns.forEach((column) => {
            // 2. This safely finds .tag elements ONLY inside this specific column
            const tags = column.querySelectorAll(".tag");

            // Only run GSAP if this specific column actually contains tags
            if (tags.length > 0) {
                gsap.from(tags, {
                    scrollTrigger: {
                        trigger: column, 
                        start: "top 90%",
                        toggleActions: "play none none none"
                    },
                    duration: 0.5,
                    scale: 0,                            
                    opacity: 1,
                    ease: "back.out(1.7)"
                });
            }
        });
    }

    //section-founders
    if (document.querySelector('.section-founders .tag')) {
        gsap.from(".section-founders .tag", {
            scrollTrigger: {
                trigger: ".section-founders",    // Element that kicks off the animation
                start: "top 10%",             // "When the top of the section hits 80% down the viewport"
                toggleActions: "play none none reset" // Plays once when entering, doesn't reverse on scroll up
            },
            
            duration: 0.5,
            scale: 0,                            
            opacity: 1,
            ease: "back.out(1.7)",
            stagger: 0.25
        });
    }

    //banner-2
    if (document.querySelector('.banner-2')) {
        gsap.from(".banner-2 .tag", {
            scrollTrigger: {
                trigger: ".banner-2",    // Element that kicks off the animation
                start: "top 50%",             // "When the top of the section hits 80% down the viewport"
                toggleActions: "play none none none" // Plays once when entering, doesn't reverse on scroll up
            },
            
            duration: 0.5,
            scale: 0,                            
            opacity: 1,
            ease: "back.out(1.7)",
            stagger: 0.25
        });
    }

    if (document.querySelector('.section-product-carousel')) {
        $('.section-product-carousel').each(function() {
            const section = $('.section-product-carousel');
            const bg = $(this).find('.graphic');
            const distance = section.hasClass('section-product-carousel') ? -60 : -10;

            gsap.to(bg, {
                y: distance,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    start: "top top",
                    end: "bottom top",
                    scrub: true
                }
            });
        });
    }

    if (document.querySelector('.banner-3')) {
        $('.banner-3').each(function() {
            const section = $('body');
            const bg = $(this).find('.bg');
            const distance = section.hasClass('banner-3') ? 500 : 300;

            gsap.to(bg, {
                y: distance,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    start: "top top",
                    end: "bottom top",
                    scrub: true
                }
            });
        });
        const tl3 = gsap.timeline();
        // Configure the precise step-by-step sequence
        tl3.from(".banner-3 h2 .mask span", {
            duration: 2,
            yPercent: 100,
            autoAlpha: 0,
            ease: "power4.out",
            stagger: 0.2
        })
    }

    if (document.querySelector('.banner-4')) {
        $('.banner-4').each(function() {
            const section = $('body');
            const bg = $(this).find('.bg');
            const distance = section.hasClass('banner-4') ? 500 : 300;

            gsap.to(bg, {
                y: distance,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    start: "top top",
                    end: "bottom top",
                    scrub: true
                }
            });
        });
        const tl4 = gsap.timeline();
        // Configure the precise step-by-step sequence
        tl4.from(".banner-4 h1 .mask span", {
            duration: 2,
            yPercent: 100,
            autoAlpha: 0,
            ease: "power4.out",
            stagger: 0.2
        })
    }

    if (document.querySelector('.banner-5')) {
        $('.banner-5').each(function() {
            const section = $('body');
            const bg = $(this).find('.bg');
            const distance = section.hasClass('banner-5') ? 500 : 300;

            gsap.to(bg, {
                y: distance,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    start: "top top",
                    end: "bottom top",
                    scrub: true
                }
            });
        });
    }

    if (document.querySelector('.banner-6')) {
        $('.banner-6').each(function() {
            const section = $('body');
            const bg = $(this).find('.bg');
            const distance = section.hasClass('banner-6') ? 500 : 300;

            gsap.to(bg, {
                y: distance,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    start: "top top",
                    end: "bottom top",
                    scrub: true
                }
            });
        });
        const tl3 = gsap.timeline();
        // Configure the precise step-by-step sequence
        tl3.from(".banner-6 h2 .mask span", {
            duration: 2,
            yPercent: 100,
            autoAlpha: 0,
            ease: "power4.out",
            stagger: 0.2
        })
    }


    if (document.querySelector('.section-story')) {
        $('.section-story').each(function() {
            const section = $('body');
            const bg = $(this).find('.bg');
            const distance = section.hasClass('section-story') ? 500 : 300;

            gsap.to(bg, {
                y: distance,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    start: "top top",
                    end: "bottom top",
                    scrub: true
                }
            });
        });

        const tl2 = gsap.timeline();
        // Configure the precise step-by-step sequence
        tl2.from(".section-story .image .tag", {
            duration: 0.5,
            scale: 0,                            
            autoAlpha: 0,
            ease: "back.out(1.7)",
            stagger: 0.25
        })

    }

    if (document.querySelector('.banner-1')) {
        gsap.from(".banner-1 h2 .mask span", {
            scrollTrigger: {
                trigger: ".banner-1",    // Element that kicks off the animation
                start: "top 50%",             // "When the top of the section hits 80% down the viewport"
                toggleActions: "play none none none" // Plays once when entering, doesn't reverse on scroll up
            },
            
            duration: 2,
            yPercent: 100,
            ease: "power4.out",
            stagger: 0.2
        });

    }


}


function runLenis(){

    // Initialize a new Lenis instance for smooth scrolling
    const lenis = new Lenis({
      anchors: true
    })
    // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
    lenis.on('scroll', ScrollTrigger.update);

    // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
    // This ensures Lenis's smooth scroll animation updates on each GSAP tick
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000); // Convert time from seconds to milliseconds
    });

    // Disable lag smoothing in GSAP to prevent any delay in scroll animations
    gsap.ticker.lagSmoothing(0);
}



function scrollAnimation(){
    // 2. Query all elements with our custom data attribute
    const scrollElements = document.querySelectorAll('[data-scroll]');

    scrollElements.forEach((el) => {
        // Grab the animation type and configuration from data attributes
        const animationType = el.getAttribute('data-scroll');
        const delay = parseFloat(el.getAttribute('data-scroll-delay')) / 1000 || 0; // Convert ms to seconds, default to 0
        
        // Set up baseline properties for our animations
        let fromVars = {
            autoAlpha: 0, // <-- CHANGED from opacity: 0 to handle visibility toggle smoothly
        };
        
        // Adjust the starting values based on the attribute value
        if (animationType === 'fade-up') {
            fromVars.y = 40;
        }

        if (animationType === 'fade-left') {
            fromVars.x = 40;
        }

        // 3. Create the GSAP scroll-triggered animation
        gsap.from(el, {
            ...fromVars,
            duration: 1.2,
            delay: delay,
            ease: 'power2.out',
            scrollTrigger: {
                trigger: el,
                start: 'top 85%', 
                toggleActions: 'play none none none', 
            }
        });
    });
}


function logoTicker(){

    const ticker = document.querySelector('.section-ticker .ticker');

    // 1. Clone the contents to create a seamless infinite loop track
    const originalContent = ticker.innerHTML;
    ticker.innerHTML = originalContent + originalContent; 

    // 2. Create the linear rolling timeline
    const marquee = gsap.to(ticker, {
      xPercent: -50,         // Move exactly half the width (the length of the original list)
      ease: "none",          // Linear motion is required for a constant speed marquee
      duration: 50,          // Time in seconds to complete one full loop (lower = faster)
      repeat: -1,            // Infinite loop
      paused: false
    });

    // 3. Hover to Pause / Play functionality
    ticker.addEventListener('mouseenter', () => {
      // Use a smooth timeScale transition so it doesn't snap abruptly to a halt
      gsap.to(marquee, { timeScale: 0, duration: 0.3, ease: "power1.out" });
    });

    ticker.addEventListener('mouseleave', () => {
      // Smoothly accelerate back to full speed (timeScale: 1)
      gsap.to(marquee, { timeScale: 1, duration: 0.3, ease: "power1.in" });
    });
}

function marquee(){

    const ticker = document.querySelector('.marquee');

    // 1. Clone the contents to create a seamless infinite loop track
    const originalContent = ticker.innerHTML;
    ticker.innerHTML = originalContent + originalContent; 

    // 2. Create the linear rolling timeline
    const marquee = gsap.to(ticker, {
      xPercent: -50,         // Move exactly half the width (the length of the original list)
      ease: "none",          // Linear motion is required for a constant speed marquee
      duration: 30,          // Time in seconds to complete one full loop (lower = faster)
      repeat: -1,            // Infinite loop
      paused: false
    });

    // 3. Hover to Pause / Play functionality
    ticker.addEventListener('mouseenter', () => {
      // Use a smooth timeScale transition so it doesn't snap abruptly to a halt
      gsap.to(marquee, { timeScale: 0, duration: 0.3, ease: "power1.out" });
    });

    ticker.addEventListener('mouseleave', () => {
      // Smoothly accelerate back to full speed (timeScale: 1)
      gsap.to(marquee, { timeScale: 1, duration: 0.3, ease: "power1.in" });
    });
}


function socialsCarousel(){
    const ticker = document.querySelector('.section-family .socials');

    // 1. Clone the contents to create a seamless infinite loop track
    const originalContent = ticker.innerHTML;
    ticker.innerHTML = originalContent + originalContent; 

    // 2. Create the linear rolling timeline
    const marquee = gsap.to(ticker, {
      xPercent: -50,         // Move exactly half the width (the length of the original list)
      ease: "none",          // Linear motion is required for a constant speed marquee
      duration: 20,          // Time in seconds to complete one full loop (lower = faster)
      repeat: -1,            // Infinite loop
      paused: false
    });

    // 3. Hover to Pause / Play functionality
    ticker.addEventListener('mouseenter', () => {
      // Use a smooth timeScale transition so it doesn't snap abruptly to a halt
      gsap.to(marquee, { timeScale: 0, duration: 0.3, ease: "power1.out" });
    });

    ticker.addEventListener('mouseleave', () => {
      // Smoothly accelerate back to full speed (timeScale: 1)
      gsap.to(marquee, { timeScale: 1, duration: 0.3, ease: "power1.in" });
    });
}

function footerAnim(){
    gsap.fromTo(
        'footer .logo img',
        {
            y: 50,      /* Start 50px below */
            opacity: 0  /* Invisible */
        },
        {
            y: 0,       /* Move to original position */
            opacity: 1, /* Fade in */
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
                trigger: 'footer',
                start: 'top 40%', /* Triggers when the top of footer hits 85% of viewport height */
                toggleActions: 'play none none reverse' /* Plays on enter, reverses if scrolled back up */
            }
        }
    );
}



document.addEventListener('DOMContentLoaded', () => {
  // Find the link inside the item that has children
  const toggleLink = document.querySelector('.mobile-menu .menu-item-has-children > a');

  if (toggleLink) {
    toggleLink.addEventListener('click', (event) => {
      // Prevent the default anchor link behavior (jumping to top of page)
      event.preventDefault(); 
      
      // Find the next sibling element, which is the <ul> sub-menu
      const subMenu = toggleLink.nextElementSibling;
      
      if (subMenu) {
        // Toggle the 'active' class on the <ul>
        subMenu.classList.toggle('active');
      }
    });
  }
});


document.querySelectorAll('a[href^="#"]:not([href="#"]):not(.modal-trigger)').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);

        if (targetElement && window.lenisInstance) {
            window.lenisInstance.scrollTo(targetElement, {
                offset: 1,
                duration: 1.2,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) // Normalizing match to Lenis profile curve
            });
        }
    });
});


document.addEventListener("DOMContentLoaded", () => {
    const triggers = document.querySelectorAll("[data-modal-target]");
    const overlays = document.querySelectorAll(".modal-overlay");

    let scrollPosition = 0;

    function openModal(modalId) {
        const modal = document.getElementById(modalId);
        if (modal) {
            // 1. Save the exact current scroll position
            scrollPosition = window.pageYOffset;
            
            // 2. Freeze the body visually exactly where it is
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollPosition}px`;
            document.body.style.width = '100%';
            
            modal.classList.add("is-active");
        }
    }

    function closeAllModals() {
        overlays.forEach(modal => {
            modal.classList.remove("is-active");
        });
        
        // 3. Unfreeze the body and restore the scroll position instantly
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollPosition);
    }

    // 1. Listen for trigger button clicks
    triggers.forEach(button => {
        button.addEventListener("click", () => {
            const targetId = button.getAttribute("data-modal-target");
            openModal(targetId);
        });
    });

    // 2. Listen for close button or overlay clicks
    overlays.forEach(overlay => {
        const closeBtn = overlay.querySelector(".modal-close");
        
        // Close on 'X' click
        if (closeBtn) {
            closeBtn.addEventListener("click", closeAllModals);
        }
        
        // Close if user clicks the dark background overlay directly
        overlay.addEventListener("click", (e) => {
            if (e.target === overlay) {
                closeAllModals();
            }
        });
    });

    // 3. Escape key safety check
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            closeAllModals();
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
  const recipeSection = document.querySelector('.section-recipes');

  if (!recipeSection) return;

  const naviListItems = recipeSection.querySelectorAll('.navi li');
  const filterButtons = recipeSection.querySelectorAll('.navi a');
  const items = recipeSection.querySelectorAll('.list .column');

  filterButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      
      // 1. Manage Active Class on <li>
      naviListItems.forEach(li => li.classList.remove('active'));
      button.parentElement.classList.add('active');

      // 2. Filter Logic & Fade-In Reset
      const selectedFilter = button.getAttribute('data-attr');

      items.forEach(item => {
        // Reset animation class so it can trigger again
        item.classList.remove('fade-in');

        const itemAttrs = item.getAttribute('data-attr') ? item.getAttribute('data-attr').split(' ') : [];

        if (selectedFilter === 'All' || itemAttrs.includes(selectedFilter)) {
          item.style.display = 'block';
          
          // Force a browser reflow to re-trigger keyframe animation reliably
          void item.offsetWidth; 
          
          // Apply animation class
          item.classList.add('fade-in');
        } else {
          item.style.display = 'none';
        }
      });
    });
  });
});
